// @ts-strict-ignore
import { createContext } from 'react';
import { FluxService } from '@/core/flux.service';

export const FluxContext = createContext<FluxService>(null);
